// -- 业务错误
export enum ErrorMessageEnum {
  NONE = 'none',
  MODAL = 'modal',
  MESSAGE = 'message',
}

// 业务状态码
export enum ErrorCodeEnum {
  TOKEN_EXPIRED = 50100, // 登录过期
  UNAUTHORIZED = 401, // 未授权
  ACCESS_DENIED = 403, // 拒绝访问
}
